
import React, { useState } from "react";
import axios from "axios";
import Logo from "../../assets/RCF-PP.jpg";

const BACKEND = process.env.REACT_APP_BACKEND_API_URL;
const API_BASE = `${BACKEND}/api/result`;

const Results = () => {
  const [searchKey, setSearchKey] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  const isSuccessCategory = (cat) =>
    ["T", "T1", "T2", "T3"].includes(cat);

  // ---------------- FULL MESSAGE TEMPLATES ----------------

  const getMessage = (cat, studentName) => {
    const name = studentName || "[STUDENT NAME]";

    const messages = {
      T: `ಆತ್ಮೀಯ ಪಾಲಕರೇ,

ಅಭಿನಂದನೆಗಳು! ನಿಮ್ಮ ಮಗ/ಮಗಳಾದ ${name} ಅವರನ್ನು ಪ್ರತಿಭಾ ಪೋಷಕ ಸಂಪೂರ್ಣ STEM ಬೆಂಬಲ ಯೋಜನೆಗೆ (Pratibha Poshak Full STEM Support Program) ಆಯ್ಕೆ ಮಾಡಲಾಗಿದೆ.

ಈ ಯೋಜನೆಯ ಅಂಗವಾಗಿ ನಿಮ್ಮ ಮಗುವಿಗೆ ಈ ಕೆಳಗಿನ ಸೌಲಭ್ಯಗಳು ಉಚಿತವಾಗಿ ದೊರೆಯಲಿವೆ:

⮚ ಖ್ಯಾತ ಶಿಕ್ಷಕರು ಮತ್ತು ವಿಜ್ಞಾನಿ ಗಳಿಂದ ಅತ್ಯುತ್ತಮ ಗುಣಮಟ್ಟದ ಆನ್‌ಲೈನ್ ತರಗತಿಗಳು
⮚ ಆನ್‌ಲೈನ್ ತರಗತಿಗಳಲ್ಲಿ ಭಾಗವಹಿಸಲು ಎರಡು ವರ್ಷಗಳ ಅವಧಿಗೆ ಒಂದು ಟ್ಯಾಬ್ (Tab)
⮚ ನಿರಂತರ ಶೈಕ್ಷಣಿಕ ಮತ್ತು ವೃತ್ತಿ ಮಾರ್ಗದರ್ಶನ
⮚ ವಸತಿ-ಸಹಿತ ಶೈಕ್ಷಣಿಕ ಮತ್ತು ವ್ಯಕ್ತಿತ್ವ ವಿಕಸನ ಶಿಬಿರಗಳು (ಪ್ರತಿಭಾ ಸಮ್ಮೇಳನಗಳು)

ಕಾರ್ಯಕ್ರಮದ ಉದ್ಘಾಟನಾ ಸಮಾರಂಭ, ತರಗತಿಗಳ ವೇಳಾಪಟ್ಟಿ ಹಾಗೂ ಮುಂದಿನ ಹಂತಗಳ ಕುರಿತು ನಮ್ಮ ತಂಡವು ಶೀಘ್ರದಲ್ಲೇ ನಿಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸುತ್ತದೆ.

ಧನ್ಯವಾದಗಳು.
ಪ್ರತಿಭಾ ಪೋಷಕ / RCF ತಂಡ
_______________________________________________________________________________________________________________________________________

Dear Parent/Guardian,

Congratulations! Your child, ${name}, has been selected to participate in the Pratibha Poshak Full STEM Support Program.

As part of this program, your child will receive the following benefits free of cost:

⮚	High quality online STEM classes from eminent teachers
⮚	A Tab (for 2 years) to enable participation in online STEM classes
⮚	Careers guidance/mentorship throughout the program
⮚	Residential STEM-preparation retreats (Pratibha Sammelans)

Our team will contact you soon with details regarding the orientation, class schedule, and the next steps. 

Thank you.
Pratibha Poshak / RCF Team


`,

      T1: `ಆತ್ಮೀಯ ಪಾಲಕರೇ,

ಅಭಿನಂದನೆಗಳು! ನಿಮ್ಮ ಮಗ/ಮಗಳಾದ  ${name} ಅವರನ್ನು ಪ್ರತಿಭಾ ಪೋಷಕ ಸಂಪೂರ್ಣ STEM ಬೆಂಬಲ ಯೋಜನೆಗೆ (Pratibha Poshak Full STEM Support Program) ಆಯ್ಕೆ ಮಾಡಲಾಗಿದೆ.

ಈ ಯೋಜನೆಯ ಅಂಗವಾಗಿ ನಿಮ್ಮ ಮಗುವಿಗೆ ಈ ಕೆಳಗಿನ ಸೌಲಭ್ಯಗಳು ಉಚಿತವಾಗಿ ದೊರೆಯಲಿವೆ:

⮚ ಖ್ಯಾತ ಶಿಕ್ಷಕರು ಮತ್ತು ವಿಜ್ಞಾನಿ ಗಳಿಂದ ಅತ್ಯುತ್ತಮ ಗುಣಮಟ್ಟದ ಆನ್‌ಲೈನ್ ತರಗತಿಗಳು
⮚ ಆನ್‌ಲೈನ್ ತರಗತಿಗಳಲ್ಲಿ ಭಾಗವಹಿಸಲು ಎರಡು ವರ್ಷಗಳ ಅವಧಿಗೆ ಒಂದು ಟ್ಯಾಬ್ (Tab)
⮚ ನಿರಂತರ ಶೈಕ್ಷಣಿಕ ಮತ್ತು ವೃತ್ತಿ ಮಾರ್ಗದರ್ಶನ
⮚ ವಸತಿ-ಸಹಿತ ಶೈಕ್ಷಣಿಕ ಮತ್ತು ವ್ಯಕ್ತಿತ್ವ ವಿಕಸನ ಶಿಬಿರಗಳು (ಪ್ರತಿಭಾ ಸಮ್ಮೇಳನಗಳು)

ಕಾರ್ಯಕ್ರಮದ ಉದ್ಘಾಟನಾ ಸಮಾರಂಭ, ತರಗತಿಗಳ ವೇಳಾಪಟ್ಟಿ ಹಾಗೂ ಮುಂದಿನ ಹಂತಗಳ ಕುರಿತು ನಮ್ಮ ತಂಡವು ಶೀಘ್ರದಲ್ಲೇ ನಿಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸುತ್ತದೆ.

ಇದರ ಜೊತೆಗೆ, ಪ್ರತಿಭಾ ಪೋಷಕ ಯೋಜನೆಯ ಮೌಲ್ಯಮಾಪನ ಮಾಡುವ ಉದ್ದೇಶದಿಂದ ಒಂದು ಅಂತರಾಷ್ಟ್ರೀಯ ಮಟ್ಟದ ಸಂಶೋಧನಾ ಅಧ್ಯಯನವನ್ನು ನಡೆಸಲಾಗುತ್ತಿದೆ. ಆರ್ಥಿಕವಾಗಿ ಹಿಂದುಳಿದ ವಿದ್ಯಾರ್ಥಿಗಳಿಗೆ ಉತ್ತಮ ಶೈಕ್ಷಣಿಕ ಅವಕಾಶಗಳನ್ನು ಒದಗಿಸಲು ಹಾಗೂ ಕಾರ್ಯಕ್ರಮವನ್ನು ಇನ್ನಷ್ಟು ಪರಿಣಾಮಕಾರಿಯಾಗಿ ರೂಪಿಸಲು ಈ ಅಧ್ಯಯನವು ಸಹಕಾರಿಯಾಗುವುದರಿಂದ, ಇದರಲ್ಲಿ ಭಾಗವಹಿಸುವಂತೆ ನಿಮ್ಮನ್ನು ವಿನಂತಿಸುತ್ತೇವೆ. ಈ ಅಧ್ಯಯನವು ನಿಮ್ಮ ಮಗುವಿನ ಶೈಕ್ಷಣಿಕ ಪ್ರಗತಿಯನ್ನು ಅರ್ಥಮಾಡಿಕೊಳ್ಳಲು ಮತ್ತು ಮೌಲ್ಯಮಾಪನ ಮಾಡಲು ಸಹ ಸಹಾಯ ಮಾಡುತ್ತದೆ. ಈ ಅಧ್ಯಯನದಲ್ಲಿ ಭಾಗವಹಿಸುವುದು ಸಂಪೂರ್ಣವಾಗಿ ಸ್ವಯಂಪ್ರೇರಿತ ಆಗಿದ್ದು, ಇದರಲ್ಲಿ ಭಾಗವಹಿಸದಿದ್ದರೂ ನಿಮ್ಮ ಮಗುವಿಗೆ ಕಾರ್ಯಕ್ರಮದ ಸೌಲಭ್ಯಗಳನ್ನು ಪಡೆಯುವಲ್ಲಿ ಯಾವುದೇ ರೀತಿಯ ಪರಿಣಾಮ ಉಂಟಾಗುವುದಿಲ್ಲ.

ಕಾರ್ಯಕ್ರಮಕ್ಕೆ ಸಂಬಂಧಿಸಿದ ಮಾಹಿತಿಗಳು ಹಾಗೂ ಮುಂಬರುವ ಚಟುವಟಿಕೆಗಳ ಕುರಿತು ಎಲ್ಲಾ ವಿಷಯಗಳನ್ನು WhatsApp ಗುಂಪಿನ ಮೂಲಕ ಹಂಚಿಕೊಳ್ಳಲಾಗುತ್ತದೆ.

ಧನ್ಯವಾದಗಳು.
ಪ್ರತಿಭಾ ಪೋಷಕ / RCF ತಂಡ

__________________________________________________________________________________________________________________________

Dear Parent/Guardian,

Congratulations! Your child, ${name}, has been selected to participate in the Pratibha Poshak Full STEM Support Program.

As part of this program, your child will receive the following benefits free of cost.

⮚	High quality online STEM classes from eminent teachers
⮚	A Tab (for 2 years) to enable participation in online STEM classes
⮚	Careers guidance/mentorship throughout the program
⮚	Residential STEM-preparation retreats (Pratibha Sammelans)

Our team will contact you soon with details regarding the orientation, class schedule, and the next steps. 

A research study is being carried out to assess the impact of Pratibha Poshak.  We request you to participate in this study, which will help in improving educational opportunities for students from disadvantaged backgrounds. This study will also help us assess your child’s academic progress over time. Participation in this research study remains voluntary and will not affect your child’s access to the program.

We will use newly created WhatsApp group to share any updates about the program and forthcoming activities. 

Thank you.
Pratibha Poshak / RCF Team
`,

      T2: `ಆತ್ಮೀಯ ಪಾಲಕರೇ,

ಪ್ರತಿಭಾ ಪೋಷಕ ಕಾರ್ಯಕ್ರಮದಲ್ಲಿ ಆಸಕ್ತಿ ತೋರಿದಕ್ಕಾಗಿ ಧನ್ಯವಾದಗಳು.

ನಿಮ್ಮ ಮಗು ಕಾರ್ಯಕ್ರಮಕ್ಕೆ ಅಗತ್ಯವಿರುವ ಕನಿಷ್ಠ ಅರ್ಹತಾ ಮಾನದಂಡಗಳನ್ನು ಪೂರೈಸಿದ್ದರೂ, ನಮ್ಮ ಕಾರ್ಯಕ್ರಮದ ಸೀಮಿತ ಸಂಪನ್ಮೂಲಗಳ ಕಾರಣದಿಂದಾಗಿ ಅವರನ್ನು ಸಂಪೂರ್ಣ STEM ಬೆಂಬಲ ಯೋಜನೆಗೆ ಆಯ್ಕೆ ಮಾಡಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ. ಆದಾಗ್ಯೂ, ನಿಮ್ಮ ಮಗುವನ್ನು ಭಾಗಶಃ STEM ಬೆಂಬಲ ಕಾರ್ಯಕ್ರಮಕ್ಕೆ ಆಯ್ಕೆ ಮಾಡಿರುವುದನ್ನು ತಿಳಿಸಲು ನಮಗೆ ಸಂತೋಷವಾಗಿದೆ.
ಈ ಕಾರ್ಯಕ್ರಮದ ಭಾಗವಾಗಿ, ನಿಮ್ಮ ಮಗುವಿಗೆ ಈ ಕೆಳಗಿನ ಸೌಲಭ್ಯಗಳನ್ನು ಉಚಿತವಾಗಿ ಒದಗಿಸಲಾಗುತ್ತದೆ:

⮚ ಎರಡು ವರ್ಷಗಳ ಅವಧಿಯಲ್ಲಿ ಒಟ್ಟಾರೆ 3 ವಸತಿ-ಸಹಿತ ಶೈಕ್ಷಣಿಕ, ವೃತ್ತಿ ಮಾರ್ಗದರ್ಶನ ಹಾಗೂ ವ್ಯಕ್ತಿತ್ವ ವಿಕಸನ ಶಿಬಿರಗಳು (ಪ್ರತಿಭಾ ಸಮ್ಮೇಳನಗಳು)

ಕಾರ್ಯಕ್ರಮದ ಮುಂದಿನ ಹಂತಗಳ ಕುರಿತು ನಮ್ಮ ತಂಡವು ನಿಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸುತ್ತದೆ.

ಇದರ ಜೊತೆಗೆ, ಪ್ರತಿಭಾ ಪೋಷಕ ಯೋಜನೆಯ ಮೌಲ್ಯಮಾಪನ ಮಾಡುವ ಉದ್ದೇಶದಿಂದ ಒಂದು ಅಂತರಾಷ್ಟ್ರೀಯ ಮಟ್ಟದ ಸಂಶೋಧನಾ ಅಧ್ಯಯನವನ್ನು ನಡೆಸಲಾಗುತ್ತಿದೆ. ಆರ್ಥಿಕವಾಗಿ ಹಿಂದುಳಿದ ವಿದ್ಯಾರ್ಥಿಗಳಿಗೆ ಉತ್ತಮ ಶೈಕ್ಷಣಿಕ ಅವಕಾಶಗಳನ್ನು ಒದಗಿಸಲು ಹಾಗೂ ಕಾರ್ಯಕ್ರಮವನ್ನು ಇನ್ನಷ್ಟು ಪರಿಣಾಮಕಾರಿಯಾಗಿ ರೂಪಿಸಲು ಈ ಅಧ್ಯಯನವು ಸಹಕಾರಿಯಾಗುವುದರಿಂದ, ಇದರಲ್ಲಿ ಭಾಗವಹಿಸುವಂತೆ ನಿಮ್ಮನ್ನು ವಿನಂತಿಸುತ್ತೇವೆ. ಈ ಅಧ್ಯಯನವು ನಿಮ್ಮ ಮಗುವಿನ ಶೈಕ್ಷಣಿಕ ಪ್ರಗತಿಯನ್ನು ಅರ್ಥಮಾಡಿಕೊಳ್ಳಲು ಮತ್ತು ಮೌಲ್ಯಮಾಪನ ಮಾಡಲು ಸಹ ಸಹಾಯ ಮಾಡುತ್ತದೆ. ಈ ಅಧ್ಯಯನದಲ್ಲಿ ಭಾಗವಹಿಸುವುದು ಸಂಪೂರ್ಣವಾಗಿ ಸ್ವಯಂಪ್ರೇರಿತ ಆಗಿದ್ದು, ಇದರಲ್ಲಿ ಭಾಗವಹಿಸದಿದ್ದರೂ ನಿಮ್ಮ ಮಗುವಿಗೆ ಕಾರ್ಯಕ್ರಮದ ಸೌಲಭ್ಯಗಳನ್ನು ಪಡೆಯುವಲ್ಲಿ ಯಾವುದೇ ರೀತಿಯ ಪರಿಣಾಮ ಉಂಟಾಗುವುದಿಲ್ಲ.

ಕಾರ್ಯಕ್ರಮಕ್ಕೆ ಸಂಬಂಧಿಸಿದ ಮಾಹಿತಿಗಳು ಹಾಗೂ ಮುಂಬರುವ ಚಟುವಟಿಕೆಗಳ ಕುರಿತು ಎಲ್ಲಾ ವಿಷಯಗಳನ್ನು WhatsApp ಗುಂಪಿನ ಮೂಲಕ ಹಂಚಿಕೊಳ್ಳಲಾಗುತ್ತದೆ.
WhatsApp ಗುಂಪನ್ನು ಸೇರಲು ಕೆಳಗೆ ನೀಡಿದ ಲಿಂಕ್ ಅನ್ನು ಕ್ಲಿಕ್ ಮಾಡಿ. 

WhatsApp Link : https://chat.whatsapp.com/Gz1LUHDNU1sJELxFAKyPk0?s=cl&p=a&ilr=4&amv=2

ಧನ್ಯವಾದಗಳು.
ಪ್ರತಿಭಾ ಪೋಷಕ / RCF ತಂಡ

__________________________________________________________________________________________________________________________

Dear Parent/Guardian,

Thank you for your interest in the Pratibha Poshak program. Although your child met the minimum eligibility conditions, we could not select him/her for the complete STEM-support program due to our budget constraints.

However, we are happy to inform you that your child has been selected to a partial-support program. As part of this partial support program your child will receive the following benefits free of cost.

⮚	A total of three residential STEM-preparation and Careers Guidance retreats (Pratibha Sammelans) in period of two years.

Our team will contact you with details regarding the next steps. 

A research study is being carried out to assess the impact of Pratibha Poshak.  We request you to participate in this study, which will help in improving educational opportunities for students from disadvantaged backgrounds. This study will also help us assess your child’s academic progress over time. Participation in this research study remains voluntary and will not affect your child’s access to the program.

We will use a Whatsapp group to share any updates about the program and forthcoming activities.
Click the following link to join the WhatsApp group. 

WhatsApp Link : https://chat.whatsapp.com/Gz1LUHDNU1sJELxFAKyPk0?s=cl&p=a&ilr=4&amv=2

Thank you.
Pratibha Poshak / RCF Team
`,

      T3: `ಆತ್ಮೀಯ ಪಾಲಕರೇ,

ಪ್ರತಿಭಾ ಪೋಷಕ ಕಾರ್ಯಕ್ರಮದಲ್ಲಿ ಆಸಕ್ತಿ ತೋರಿದಕ್ಕಾಗಿ ಧನ್ಯವಾದಗಳು.

ನಿಮ್ಮ ಮಗು ಕಾರ್ಯಕ್ರಮಕ್ಕೆ ಅಗತ್ಯವಿರುವ ಕನಿಷ್ಠ ಅರ್ಹತಾ ಮಾನದಂಡಗಳನ್ನು ಪೂರೈಸಿದ್ದರೂ, ನಮ್ಮ ಕಾರ್ಯಕ್ರಮದ ಸೀಮಿತ ಸಂಪನ್ಮೂಲಗಳ ಕಾರಣದಿಂದಾಗಿ ಈ ವರ್ಷ ಅವರನ್ನು ಕಾರ್ಯಕ್ರಮಕ್ಕೆ ಆಯ್ಕೆ ಮಾಡಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ.

ಆದಾಗ್ಯೂ, ದಯವಿಟ್ಟು ನಿರಾಶರಾಗಬೇಡಿ. ವಿದ್ಯಾರ್ಥಿಗಳಿಗೆ ಉಪಯುಕ್ತವಾಗುವ ವಿವಿಧ ಶೈಕ್ಷಣಿಕ ಮಾಹಿತಿ, ನಮಗೆ ತಿಳಿಯುವ ಇತರೆ ಅವಕಾಶಗಳು ಹಾಗೂ ಮುಂದಿನ ದಿನಗಳಲ್ಲಿ ಲಭ್ಯವಾಗುವ ಮಾಹಿತಿಗಳನ್ನು ನಮ್ಮ WhatsApp ಗುಂಪಿನ ಮೂಲಕ ನಿಮ್ಮೊಂದಿಗೆ ಹಂಚಿಕೊಳ್ಳಲಾಗುತ್ತದೆ.

ಪ್ರತಿಭಾ ಪೋಷಕ ಯೋಜನೆಯ ಮೌಲ್ಯಮಾಪನ ಮಾಡುವ ಉದ್ದೇಶದಿಂದ ಒಂದು ಅಂತರಾಷ್ಟ್ರೀಯ ಮಟ್ಟದ ಸಂಶೋಧನಾ ಅಧ್ಯಯನವನ್ನು ನಡೆಸಲಾಗುತ್ತಿದೆ. ಈ ಅಧ್ಯಯನದಲ್ಲಿ ಭಾಗವಹಿಸಲು ನೀವು ಸಮ್ಮತಿಸಿದಲ್ಲಿ, ಮುಂದಿನ ದಿನಗಳಲ್ಲಿ ನಡೆಯುವ ಸಮೀಕ್ಷೆಗಳು (Surveys) ಹಾಗೂ ಮೌಲ್ಯಮಾಪನಗಳಲ್ಲಿ (Assessments) ಭಾಗವಹಿಸಲು ನಾವು ನಿಮ್ಮ ಮಗುವನ್ನು ಆಹ್ವಾನಿಸಬಹುದು. ಈ ಸಂಶೋಧನಾ ಅಧ್ಯಯನದಲ್ಲಿ ಭಾಗವಹಿಸುವುದು ಸಂಪೂರ್ಣವಾಗಿ ಸ್ವಯಂಪ್ರೇರಿತವಾಗಿದೆ. ಆದಾಗ್ಯೂ, ಆರ್ಥಿಕವಾಗಿ ಹಿಂದುಳಿದ  ವಿದ್ಯಾರ್ಥಿಗಳಿಗೆ ಉತ್ತಮ ಶೈಕ್ಷಣಿಕ ಅವಕಾಶಗಳನ್ನು ರೂಪಿಸಲು ಹಾಗೂ ಕಾರ್ಯಕ್ರಮಗಳನ್ನು ಇನ್ನಷ್ಟು ಪರಿಣಾಮಕಾರಿಯಾಗಿ ಅಭಿವೃದ್ಧಿಪಡಿಸಲು ಈ ಅಧ್ಯಯನವು ಸಹಕಾರಿಯಾಗುವುದರಿಂದ, ಇದರಲ್ಲಿ ಭಾಗವಹಿಸುವಂತೆ ನಿಮ್ಮನ್ನು ವಿನಂತಿಸುತ್ತೇವೆ. ಈ ಅಧ್ಯಯನವು ನಿಮ್ಮ ಮಗುವಿನ ಶೈಕ್ಷಣಿಕ ಪ್ರಗತಿಯನ್ನು ಅರ್ಥಮಾಡಿಕೊಳ್ಳಲು ಮತ್ತು ಮೌಲ್ಯಮಾಪನ ಮಾಡಲು ಸಹ ಸಹಾಯ ಮಾಡುತ್ತದೆ.
ಕಾರ್ಯಕ್ರಮಕ್ಕೆ ಸಂಬಂಧಿಸಿದ ಮಾಹಿತಿಗಳು ಹಾಗೂ ಮುಂಬರುವ ಚಟುವಟಿಕೆಗಳ ಕುರಿತು ಎಲ್ಲಾ ವಿಷಯಗಳನ್ನು WhatsApp ಗುಂಪಿನ ಮೂಲಕ ಹಂಚಿಕೊಳ್ಳಲಾಗುತ್ತದೆ.
WhatsApp ಗುಂಪನ್ನು ಸೇರಲು ಕೆಳಗೆ ನೀಡಿದ ಲಿಂಕ್ ಅನ್ನು ಕ್ಲಿಕ್ ಮಾಡಿ. 

WhatsApp Link : https://chat.whatsapp.com/J80Em8ePj3WKYctkDdCiFH?s=cl&p=a&ilr=4&amv=2

ಧನ್ಯವಾದಗಳು.
ಪ್ರತಿಭಾ ಪೋಷಕ / RCF ತಂಡ
__________________________________________________________________________________________________________________________

Dear Parent/Guardian,

Thank you for your interest in the Pratibha Poshak program. Although your child met the eligibility conditions, we could not select him/her for the program this year due to our budget constraints.

However, we hope that you do not get disheartened and we can stay in touch through the Whatsapp group where we will share other opportunities that we come across or share other information which may be academically useful for students. 

A research study is being carried out to assess the impact of Pratibha Poshak.  If you agree to participate in this research study, your child may still be invited to complete future surveys and assessments. Although participation in this research study is voluntary, we request you to participate in this study which will help in improving educational opportunities for students from disadvantaged backgrounds.  This study will also help us assess your child’s academic progress over time.

To join the research study, get educational information and other updates please join our WhatsApp group by clicking the following link.

WhatsApp Link : https://chat.whatsapp.com/J80Em8ePj3WKYctkDdCiFH?s=cl&p=a&ilr=4&amv=2

Thank you.
Pratibha Poshak / RCF Team

`,

     // T4: `Dear Parent/Guardian, \n \nWe regret to inform you that your child  ${name} has not been selected for the Pratibha Poshak program. We wish him/her all the best and hope to be able to enroll him/her to our ASCEND program after completion of SSLC (10th).`
    T4: `ಆತ್ಮೀಯ ಪಾಲಕರೇ,

ನಿಮ್ಮ ಮಗ/ಮಗಳಾದ ${name} ಅವರನ್ನು ಪ್ರತಿಭಾ ಪೋಷಕ ಕಾರ್ಯಕ್ರಮಕ್ಕೆ ಆಯ್ಕೆ ಮಾಡಲು ಸಾಧ್ಯವಾಗಿಲ್ಲ ಎಂದು ತಿಳಿಸಲು ವಿಷಾದಿಸುತ್ತೇವೆ. ಅವರ ಭವಿಷ್ಯಕ್ಕೆ ನಮ್ಮ ಶುಭ ಹಾರೈಕೆಗಳು ಮತ್ತು ಎಸ್‌ಎಸ್‌ಎಲ್‌ಸಿ (10ನೇ ತರಗತಿ) ಮುಗಿದ ನಂತರ ಅವರನ್ನು ನಮ್ಮ 'ASCEND' ಕಾರ್ಯಕ್ರಮಕ್ಕೆ ಸೇರಿಸಿಕೊಳ್ಳಲು ನಾವು ಆಶಿಸುತ್ತೇವೆ.

ಧನ್ಯವಾದಗಳು.
ಪ್ರತಿಭಾ ಪೋಷಕ / RCF ತಂಡ
__________________________________________________________________________________________________________________________

Dear Parent/Guardian, 

We regret to inform you that your child ${name} has not been selected for the Pratibha Poshak program. We wish him/her all the best and hope to be able to enroll him/her to our ASCEND program after completion of SSLC (10th). \n\n Thank you \n PRATIBHA POSHAK / RCF TEAM`
    };

    return messages[cat] || "";
  };

  // ---------------- SEARCH ----------------

  const searchResult = async () => {
    if (!searchKey.trim()) return;

    setLoading(true);
    setError("");
    setData(null);

    try {
      const res = await axios.get(`${API_BASE}/${searchKey}`);
      setData(res.data.data);
    } catch (err) {
      setError("Incorrect Id , Please check your Id!!");
    } finally {
      setLoading(false);
    }
  };

  // ---------------- NATIVE PRINT (TEXT-SELECTABLE PDF) ----------------

  const handlePrint = () => {
    window.print();
  };

  // ---------------- PARSE LINKS IN TEXT ----------------
  const renderTextWithLinks = (text) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.split(urlRegex).map((part, index) => {
      if (part.match(urlRegex)) {
        return (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#2563eb", textDecoration: "underline" }}
          >
            {part}
          </a>
        );
      }
      return part;
    });
  };

  // ---------------- UI ----------------

  return (
    <div
      className="scroll-container"
      style={{
        height: "100vh",     
        background: "#f3f4f6",
        padding: 30,
        overflowY: "auto",   
      }}
    >
      <style>
        {`
          @media print {
            /* 1. Force the root elements to expand to full document height */
            html, body {
              height: auto !important;
              min-height: 100% !important;
              overflow: visible !important;
              margin: 0 !important;
              padding: 0 !important;
              background: #fff !important;
            }

            .hide-on-print {
              display: none !important;
            }

            /* 2. Aggressively override the inline scroll logic for the container */
            .scroll-container {
              height: auto !important;
              max-height: none !important;
              overflow: visible !important;
              overflow-y: visible !important; /* Targets the specific inline style */
              padding: 0 !important;
              background: #fff !important;
              display: block !important;
            }

            /* 3. Setup the PDF layout */
            #pdf-content {
              width: 100%;
              margin: 0;
              padding: 0;
              box-shadow: none;
              page-break-inside: auto; /* Allow pages to split */
            }

            /* 4. Ensure the large text blocks break correctly */
            pre {
              white-space: pre-wrap !important;
              word-wrap: break-word !important;
              page-break-inside: auto !important;
            }

            @page {
              size: A4 portrait;
              margin: 20mm;
            }
          }
        `}
      </style>

      <div style={{ maxWidth: 900, margin: "auto" }}>

        {/* HEADER */}
        <div className="hide-on-print" style={{ display: "flex", background: "#fff", padding: 15, borderRadius: 8 }}>
          <img src={Logo} alt="Logo" style={{ width: 80, marginRight: 15 }} />
          <div>
            <h2>PRATIBHA POSHAK RESULT - 2026</h2>
          </div>
        </div>

        {/* INSTRUCTIONS SECTION */}
        <div className="hide-on-print" style={{
          background: "#e0f2fe",
          padding: "20px",
          borderRadius: "8px",
          marginTop: "20px",
          borderLeft: "5px solid #3b82f6",
          boxShadow: "0 2px 4px rgba(0,0,0,0.05)"
        }}>
          <h3 style={{ marginTop: 0, color: "#1e3a8a", fontSize: "16px", marginBottom: "10px" }}>
            ನಿಮ್ಮ ಫಲಿತಾಂಶವನ್ನು ವೀಕ್ಷಿಸುವುದು ಹೇಗೆ:
          </h3>
          <ul style={{ margin: 0, paddingLeft: "20px", color: "#334155", fontSize: "15px", lineHeight: "1.6" }}>
            <li>ಕೆಳಗಿನ search box ನಲ್ಲಿ  ನಿಮ್ಮ <strong>NMMS ನೋಂದಣಿ ಸಂಖ್ಯೆ (Registration Number)</strong> ಅಥವಾ <strong>PP ಹಾಲ್ ಟಿಕೆಟ್ ಸಂಖ್ಯೆ</strong> ಅಥವಾ <strong>ವಿದ್ಯಾರ್ಥಿ ಸ್ಯಾಟ್ಸ್ ಐಡಿ (SATS ID)</strong> ಅನ್ನು ನಮೂದಿಸಿ.</li>
            <li>ನಿಮ್ಮ ಫಲಿತಾಂಶವನ್ನು ವೀಕ್ಷಿಸಲು <strong>Submit</strong> ಬಟನ್ ಮೇಲೆ ಕ್ಲಿಕ್ ಮಾಡಿ.</li>
            <li>ಫಲಿತಾಂಶವನ್ನು ಡೌನ್‌ಲೋಡ್ ಮಾಡಲು ಕೆಳಗಿರುವ <strong>Export PDF</strong> ಬಟನ್ ಕ್ಲಿಕ್ ಮಾಡಿ.</li>
          </ul>
          <hr style={{ margin: "15px 0", borderColor: "#bfdbfe" }} />
          <h3 style={{ marginTop: 0, color: "#1e3a8a", fontSize: "16px", marginBottom: "10px" }}>
            How to check your result:
          </h3>
          <ul style={{ margin: 0, paddingLeft: "20px", color: "#334155", fontSize: "15px", lineHeight: "1.6" }}>
            <li>Enter your <strong>NMMS Registration Number</strong> or <strong>PP Hall Ticket Number</strong> or <strong>SATS ID</strong> in the search box below.</li>
            <li>Click the <strong>Submit</strong> button to view your selection status.</li>
            <li>If your result is displayed, click the <strong>Export PDF</strong> button at the bottom to download your Result.</li>
          </ul>
        </div>

        {/* SEARCH */}
        <div className="hide-on-print" style={{ display: "flex", gap: 10, marginTop: 10 }}>
          <input
            type="text"
            value={searchKey}
            onChange={(e) => {
              const onlyNumbers = e.target.value.replace(/\D/g, "");
              setSearchKey(onlyNumbers);
            }}
            style={{ flex: 1, padding: 12, fontSize: "16px", borderRadius: 4, border: "1px solid #ccc" }}
            placeholder="PLEASE ENTER NMMS REG NUMBER / PP HALL TICKET NUMBER / SATS ID"
          />
          <button
            onClick={searchResult}
            style={{
              padding: "12px 24px",
              cursor: "pointer",
              background: "#3b82f6",
              color: "#fff",
              border: "none",
              borderRadius: 4,
              fontWeight: "bold"
            }}
          >
            {loading ? "Searching..." : "Submit"}
          </button>
        </div>

        {error && <p className="hide-on-print" style={{ color: "red", marginTop: 15 }}>{error}</p>}

        {/* RESULT */}
        {data && (
          <div style={{ marginTop: 20, background: "#fff", padding: 20, borderRadius: 8 }}>

            {/* --- WRAPPER FOR PDF EXPORT --- */}
            <div id="pdf-content" style={{ background: "#fff", color: "#000" }}>
              <div style={{ display: "flex", alignItems: "center", marginBottom: 20 }}>
                <img src={Logo} alt="Logo" style={{ width: 60, marginRight: 15 }} />
                <h2 style={{ margin: 0 }}>Pratibha Poshak Result</h2>
              </div>

              <h3 style={{
                textAlign: "center",
                background: isSuccessCategory(data.result_category) ? "#22c55e" : "#ef4444",
                color: "#fff",
                padding: 10,
                borderRadius: 4,
                WebkitPrintColorAdjust: "exact",
                printColorAdjust: "exact"
              }}>
                {isSuccessCategory(data.result_category)
                  ? "🎉 PRATIBHA POSHAK RESULT - 2026 🎉"
                  : "Thank You for Participating!!"}
              </h3>

              <div style={{ margin: "20px 0" }}>
                <p><b>STUDENT NAME : </b> {data.student_name}</p>
                <p><b>NMMS REG NUMBER : </b> {data.nmms_reg_number}</p>
                <p><b>PP HALLTICKET NUMBER : </b> {data.pp_hall_ticket_no}</p>
              </div>

              <hr style={{ borderColor: "#eee", margin: "20px 0" }} />

              <pre style={{
                whiteSpace: "pre-wrap",
                fontFamily: "inherit",
                fontSize: "14px",
                lineHeight: "1.5"
              }}>
                {renderTextWithLinks(getMessage(data.result_category, data.student_name))}
              </pre>
            </div>
            {/* --- END WRAPPER --- */}

            <button
              className="hide-on-print"
              onClick={handlePrint}
              style={{
                marginTop: "20px",
                padding: "12px 24px",
                background: "#10b981",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                fontSize: "16px",
                cursor: "pointer",
                fontWeight: "bold",
                width: "100%"
              }}
            >
              Export PDF
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Results;